// extracted by mini-css-extract-plugin
export var section = "banner-module--section--+3+wL";
export var img = "banner-module--img--8N+kK";
export var container = "banner-module--container--C-5CN";
export var title = "banner-module--title--FV-CO";
export var subTitle = "banner-module--subTitle--WVarC";
export var br1 = "banner-module--br1--dDifb";
export var br2 = "banner-module--br2--rVOOI";
export var btn = "banner-module--btn--pQiBo";